import { onBeforeClose, openDrawer } from "@/src/components/dialogs";
import { FolderItemTitle } from "@/src/components/folderItemTitle";
import { Appointment, Consultation, Income } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId, jsonAbstract } from "@/src/utils/utils";
import { openIncomeForm } from "../accounting/incomeForm";
import { getStandardConfidentiality } from "../patients/confidentialitiesHook";
import { ConsultationPage } from "./consultationPage";

export async function openConsultation(
  appointment: Appointment,
  onConfirm: (appointment: Appointment) => void
) {
  let patient = appointment.patient;
  let consultation: Consultation | null | undefined = null;
  if (appointment.item)
    consultation = await apiFetch("consultations", "loadById", {
      id: jsonAbstract(appointment.item?.id || appointment.item),
    });

  consultation ||= {
    id: getItemId(appointment.item),
    type: "consultation",
    patient,
    creator: getUserId(),
    confidentiality: getStandardConfidentiality(patient),
    readBy: [],
    functionalSigns: [],
    physicalSigns: [],
  };

  if (!consultation.id) {
    let result = await apiFetch("consultations", "addOne", {
      consultation,
    });
    if (!result) return;
    consultation = result;
  }

  let item = await apiFetch("consultations", "loadById", {
    id: consultation.id,
  });

  if (!item) return;

  await openDrawer({
    id: "consultationDrawer",
    title: (
      <FolderItemTitle
        currentPatient={appointment.patient}
        parent={item}
        showDischargeButton={false}
      ></FolderItemTitle>
    ),
    content: <ConsultationPage patient={appointment.patient!} item={item} />,
    onBeforeClose: onBeforeClose,
    onConfirm: async (e) => {
      let result = await apiFetch("consultations", "addOne", {
        consultation: item,
      });
      if (!result) return;
      consultation = result;
      await apiFetch("appointments", "addOne", {
        appointment: {
          ...appointment,
          item: getItemId(consultation),
          status: "finished",
        },
      });

      await openIncomeForm({ parent: item, patient: consultation.patient! });
      onConfirm(appointment);
    },
  });
}
